import { render, staticRenderFns } from "./dissolvePackage.vue?vue&type=template&id=11ba482e&scoped=true"
import script from "./dissolvePackage.vue?vue&type=script&lang=js"
export * from "./dissolvePackage.vue?vue&type=script&lang=js"
import style0 from "./dissolvePackage.vue?vue&type=style&index=0&id=11ba482e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ba482e",
  null
  
)

export default component.exports